import { useState } from "react";

const ToggleTabs = ({ tabs = [], className = "", onTabChange = null }) => {
  const [activeTabId, setActiveTabId] = useState(tabs[0]?.id || null);

  if (!tabs.length) return null;

  const handleTabClick = (tabId, originalOnClick) => {
    setActiveTabId(tabId);
    if (onTabChange) {
      onTabChange(tabId);
    }
    if (originalOnClick) {
      originalOnClick();
    }
  };

  return (
    <div className={`mb-4 flex flex-wrap items-center gap-2 ${className}`}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId;

        return (
          <button
            key={tab.id || tab.label}
            type="button"
            onClick={() => handleTabClick(tab.id, tab.onClick)}
            className={`flex items-center justify-center rounded-t-lg border border-b-0 px-4 py-2 text-sm font-semibold transition ${
              isActive
                ? tab.activeClassName || "border-blue-200 bg-blue-600 text-white shadow-sm"
                : tab.inactiveClassName || "border-slate-200 bg-white text-slate-700 hover:bg-slate-50"
            }`}
            aria-label={tab.ariaLabel || tab.label}
            title={tab.title || tab.label}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default ToggleTabs;
